import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import AzButton from '~/components/_next/atoms/AzButton.vue';
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import RenderContent from '~/components/cms/page/RenderContent.vue';
import useProductContent from '@/composables/useProductContent/useProductContent';
export default defineComponent({
  name: 'BlockCategorizedTabContainer',
  components: {
    AzButton: AzButton,
    NativeCarousel: NativeCarousel,
    RenderContent: RenderContent
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    catchphrase: {
      type: String,
      default: ''
    },
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var currentActiveTabIndex = ref(0);
    var components = computed(function () {
      return props.tabs ? mapComponentName(props.tabs) : [];
    });
    var aggregatedTabs = computed(function () {
      return aggregateComponents(components.value);
    });
    var currentTab = computed(function () {
      return aggregatedTabs.value[currentActiveTabIndex.value].components;
    });
    var setCurrentTab = function setCurrentTab(index) {
      currentActiveTabIndex.value = index;
    };

    // Aggregate all components by the category
    var aggregateComponents = function aggregateComponents(components) {
      var aggreatedComponents = components.reduce(function (componentsByCatName, component) {
        var _component$fields, _category$sys, _category$fields;
        var category = (_component$fields = component.fields) === null || _component$fields === void 0 ? void 0 : _component$fields.category;
        var categoryID = category === null || category === void 0 ? void 0 : (_category$sys = category.sys) === null || _category$sys === void 0 ? void 0 : _category$sys.id;
        if (!categoryID) return componentsByCatName;
        var categoryName = (_category$fields = category.fields) === null || _category$fields === void 0 ? void 0 : _category$fields.category;
        if (categoryName) {
          var _component$fields2;
          if (!componentsByCatName[categoryID]) {
            componentsByCatName[categoryID] = {
              name: categoryName,
              components: []
            };
          }
          if ((_component$fields2 = component.fields) !== null && _component$fields2 !== void 0 && _component$fields2.title) componentsByCatName[categoryID].components.push(component);
        }
        return componentsByCatName;
      }, {});
      return Object.values(aggreatedComponents);
    };
    return {
      aggregatedTabs: aggregatedTabs,
      currentActiveTabIndex: currentActiveTabIndex,
      currentTab: currentTab,
      setCurrentTab: setCurrentTab
    };
  }
});